export const GET_PARTNERS_API_REQUEST = 'GET_PARTNERS_API_REQUEST';
export const GET_PARTNERS_API_SUCCESS = 'GET_PARTNERS_API_SUCCESS';
export const GET_PARTNERS_API_ERROR = 'GET_PARTNERS_API_ERROR';